// src/components/sections/News.js
import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { fetchLandingContent } from '../../api/landing';
import { withLanguage } from '../../context/LanguageContext';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class News extends React.Component {
  state = {
    useCases: null
  };

  componentDidMount() {
    fetchLandingContent()
      .then((res) => {
        if (res?.success && res.data?.use_cases) {
          this.setState({ useCases: res.data.use_cases });
        }
      })
      .catch((err) => console.error("Failed to fetch use cases", err));
  }

  render() {
    const { text, isEnglish } = this.props;
    const englishUseCases = [
      {
        title: 'Structuring faxed invoices',
        description: 'Wholesalers exchange many document formats with diverse partners. Digitizing faxed invoices and paper delivery notes removes a major obstacle to productive accounting workflows.'
      },
      {
        title: 'Paper forms in manufacturing',
        description: 'Manufacturing floors are often separated from PC environments. PITHIAS converts work orders, inspection reports, and production logs into usable data without repetitive manual entry.'
      },
      {
        title: 'Digitizing laboratory notebooks',
        description: 'Handwritten laboratory notebooks contain valuable research knowledge. Digitization makes that knowledge searchable and helps accelerate research, innovation, and customer value.'
      }
    ];

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'news section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'news-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: text('ユースケース', 'Use cases'),
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" />
            <div className={tilesClasses}>

              {this.state.useCases ? (
                this.state.useCases.map((uc, idx) => (
                  <div key={idx} className="tiles-item">
                    <div className="tiles-item-inner has-shadow">
                      <figure className={`news-item-image m-0 ${idx === 0 ? 'news-image' : ''}`}>
                        <Image
                          className={idx === 0 ? 'news-image--first' : 'news-image'}
                          src={(uc.imagePath.startsWith('http') || uc.imagePath.startsWith('data:')) ? uc.imagePath : require(`./../../assets/images/${uc.imagePath}`)}
                          alt={`News ${idx + 1}`}
                          width={344}
                          height={194}
                        />
                      </figure>
                      <div className="news-item-content">
                        <div className="news-item-body">
                          <h3 className="news-item-title h4 mt-0 mb-8">
                            <a>{isEnglish ? (uc.titleEn || englishUseCases[idx]?.title || uc.title) : uc.title}</a>
                          </h3>
                          <p 
                            className="mb-16 text-sm" 
                            dangerouslySetInnerHTML={{ __html: isEnglish ? (uc.descriptionEn || englishUseCases[idx]?.description || uc.description) : uc.description }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <>
                  {/* ---------------------------
                      CARD 1 — Custom Image Size
                     --------------------------- */}
                  <div className="tiles-item reveal-from-bottom">
                    <div className="tiles-item-inner has-shadow">
                      <figure className="news-item-image m-0 news-image">   {/* wrapper keeps the .news-image */}
                        <Image
                          className="news-image--first"                     /* single token only */
                          src={require('./../../assets/images/printer-2339136_1920.jpg')}
                          alt="News 01"
                          width={344}
                          height={194}
                        />
                      </figure>
                      <div className="news-item-content">
                        <div className="news-item-body">
                          <h3 className="news-item-title h4 mt-0 mb-8">
                            <a>{text('FAX請求書の構造化', englishUseCases[0].title)}</a>
                          </h3>
                          <p className="mb-16 text-sm">{text(
                            '卸売業は多種多様な取引先と様々な帳票をやり取りしています。中にはFAXで送付される請求書や紙で添付される納品書もあり、これをデータ化して会計システムに入力する作業は、生産性向上の大きな足かせになっています。',
                            englishUseCases[0].description
                          )}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---------------------------
                      CARD 2 — Normal
                     --------------------------- */}
                  <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                    <div className="tiles-item-inner has-shadow">
                      <figure className="news-item-image m-0">
                        <Image
                          className="news-image"
                          src={require('./../../assets/images/metal-rod-72700_1920.jpg')}
                          alt="News 02"
                          width={344}
                          height={194}
                        />
                      </figure>
                      <div className="news-item-content">
                        <div className="news-item-body">
                          <h3 className="news-item-title h4 mt-0 mb-8">
                            <a>{text('製造現場の紙帳票', englishUseCases[1].title)}</a>
                          </h3>
                          <p className="mb-16 text-sm">{text(
                            '製造現場は、多くの場合PC環境から隔離されています。この現場で作成される、作業指示書・品質検査報告書・生産日報などをデータとして活用するためには、追加の、そして生産性の低い労力が必要です。',
                            englishUseCases[1].description
                          )}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ---------------------------
                      CARD 3 — Normal
                     --------------------------- */}
                  <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
                    <div className="tiles-item-inner has-shadow">
                      <figure className="news-item-image m-0">
                        <Image
                          className="news-image"
                          src={require('./../../assets/images/iStock-849469292.jpg')}
                          alt="News 03"
                          width={344}
                          height={194}
                        />
                      </figure>
                      <div className="news-item-content">
                        <div className="news-item-body">
                          <h3 className="news-item-title h4 mt-0 mb-8">
                            <a>{text('実験ノートのデータ化', englishUseCases[2].title)}</a>
                          </h3>
                          <p className="mb-16 text-sm">{text(
                            '研究者の知恵が詰まった手書きの実験ノートは、貴社のかけがえのない資産です。この埋もれた知見をデータ化して蘇らせることで、研究開発のスピードを加速させ、新たなイノベーションと顧客満足の創出につなげます。',
                            englishUseCases[2].description
                          )}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </section>
    );
  }
}

News.propTypes = propTypes;
News.defaultProps = defaultProps;

export default withLanguage(News);
